import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import moment from "moment";
import { useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { usePDF } from "react-to-pdf";
import { useReactToPrint } from "react-to-print";
import { Col, Row, Table } from "reactstrap";
import logo from "../../assets/imgs/pdf-logo.png";
import BackButton from "../../components/button/BackButton";
import GeneralButton from "../../components/button/GeneralButton";
import PageName from "../../components/react_helmet/PageName";
import { formatNumberWithCommas, uploadBlobAndSendEmail } from "../../helpers/helpers";
const Invoice = () => {
  const { state } = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [orderLabels, setOrderLabels] = useState([]);

  const [calculatedSubtotal, setCalculatedSubtotal] = useState(0);
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const printContentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: printContentRef,
    documentTitle: `Invoice_${state?.id || "order"}`,
    pageStyle: `
      @page {
        size: letter portrait;
        margin: 8mm 10mm !important;
      }
      @media print {
        html, body {
          width: 100% !important;
          height: auto !important;
          margin: 0 !important;
          padding: 0 !important;
          background: #fff !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }
    `,
  });

  const downloadPDFObj = usePDF({ filename: `Invoice#${state?.id}.pdf`, method: "build" });
  const generatePDFObj = usePDF({ filename: `Invoice#${state?.id}.pdf` });
  const generatePDF = async () => {
    if (handlePrint) {
      handlePrint();
    } else {
      await generatePDFObj?.toPDF();
    }
  };
  const sendPdfToEmail = async () => {
    setLoading(true);
    const res = await downloadPDFObj?.toPDF();
    const pdfBlob = res.output("blob");
    await uploadBlobAndSendEmail(
      pdfBlob,
      "invoicePDF",
      state?._id,
      "Invoice",
      "Orders",
      setLoading,
      state?.id,
      state?.billing?.email
    );
  };
  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection("Trackings")
      .where("orderId", "==", state?._id)
      .onSnapshot((querySnapshot) => {
        const labelsData = [];
        querySnapshot.forEach((doc) => labelsData.push(doc.data()));
        setOrderLabels(labelsData ?? []);
      });
    return () => unsubscribe();
  }, [state?._id]);

  useEffect(() => {
    const subTotal = state?.line_items?.reduce((acc, item) => {
      const price = parseFloat(item?.price ?? 0);
      const qty = parseFloat(item?.quantity ?? 0);
      return acc + price * qty;
    }, 0);
    const taxRate = parseFloat(state?.totalTaxAmount?.tax ?? 0);
    const shipping = parseFloat(state?.totalTaxAmount?.shippingAmount ?? 0);
    const insurance = parseFloat(state?.totalTaxAmount?.insurance ?? 0);
    const discount = parseFloat(state?.totalTaxAmount?.discount ?? 0);
    const taxAmount = (subTotal * taxRate) / 100;
    const total = subTotal + taxAmount + shipping + insurance - discount;
    setCalculatedSubtotal(subTotal);
    setTotalTax(taxAmount);
    setCalculatedTotal(total);
  }, [state]);
  if (!state) return <p>Loading...</p>;


  console.log('state', state)
  return (
    <>
      <BackButton handleClick={() => history.goBack()} />

      <div className="d-flex justify-content-center bg-light py-4">
        <section
          className="p-4 bg-white shadow-sm pdf-container"
          ref={(el) => {
            printContentRef.current = el;
            if (downloadPDFObj?.targetRef) downloadPDFObj.targetRef.current = el;
            if (generatePDFObj?.targetRef) generatePDFObj.targetRef.current = el;
          }}
          style={{ width: "1000px", maxWidth: "1000px", color: "#333", fontSize: "14px", border: "1px solid #dee2e6", margin: "0 auto" }}
        >
          <style>
            {`
              .invoice-card {
                background-color: #fff;
                border: 1px solid #dee2e6;
                border-radius: 4px;
                overflow: hidden;
              }
              .invoice-card-header {
                background-color: #f0f0f0;
                color: #000;
                font-weight: 700;
                font-size: 12.5px;
                letter-spacing: 0.5px;
                padding: 7px 14px;
                text-transform: uppercase;
                border-bottom: 1px solid #dee2e6;
              }
              .invoice-card-body {
                padding: 12px 16px;
                font-size: 13.5px;
                line-height: 1.5;
              }
              .invoice-card-body p {
                margin-bottom: 3px;
              }
              .info-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 5px 0;
                border-bottom: 1px solid #dee2e6;
                font-size: 13.5px;
              }
              .info-row:last-child {
                border-bottom: none;
                padding-bottom: 0;
              }
              .invoice-table th {
                background-color: #f0f0f0 !important;
                color: #000 !important;
                font-size: 12px;
                font-weight: 700;
                text-transform: uppercase;
                padding: 8px 10px !important;
                border-color: #dee2e6 !important;
              }
              .invoice-table td {
                padding: 8px 10px !important;
                font-size: 13px;
                border-color: #dee2e6 !important;
              }

              @media print {
                @page {
                  size: letter portrait;
                  margin: 8mm 10mm !important;
                }
                html, body {
                  width: 100% !important;
                  height: auto !important;
                  background: #fff !important;
                  margin: 0 !important;
                  padding: 0 !important;
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
                .pdf-container {
                  width: 100% !important;
                  min-width: 100% !important;
                  max-width: 100% !important;
                  margin: 0 !important;
                  padding: 0 !important;
                  border: none !important;
                  box-shadow: none !important;
                  font-size: 12px !important;
                  line-height: 1.4 !important;
                  page-break-inside: avoid !important;
                  break-inside: avoid !important;
                }
                .pdf-container * {
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
                .pdf-header {
                  margin-bottom: 16px !important;
                  padding-bottom: 10px !important;
                }
                .pdf-logo {
                  max-height: 50px !important;
                  max-width: 210px !important;
                }
                .pdf-title {
                  font-size: 26px !important;
                  margin-bottom: 2px !important;
                }
                .pdf-meta {
                  font-size: 12.5px !important;
                  line-height: 1.35 !important;
                }
                .row-2-col {
                  display: flex !important;
                  flex-direction: row !important;
                  width: 100% !important;
                  gap: 16px !important;
                  margin-bottom: 16px !important;
                }
                .col-half {
                  width: 50% !important;
                  flex: 1 1 50% !important;
                }
                .invoice-card {
                  border: 1px solid #dee2e6 !important;
                }
                .invoice-card-header {
                  font-size: 11.5px !important;
                  padding: 6px 12px !important;
                  background-color: #f0f0f0 !important;
                }
                .invoice-card-body {
                  padding: 10px 14px !important;
                  font-size: 12px !important;
                  line-height: 1.4 !important;
                }
                .invoice-card-body p {
                  margin-bottom: 3px !important;
                  font-size: 12px !important;
                }
                .info-row {
                  padding: 4px 0 !important;
                  font-size: 12px !important;
                }
                .invoice-table {
                  margin-bottom: 16px !important;
                }
                .invoice-table th {
                  font-size: 11px !important;
                  padding: 6px 8px !important;
                  background-color: #f0f0f0 !important;
                }
                .invoice-table td {
                  font-size: 11.5px !important;
                  padding: 7px 8px !important;
                }
                .totals-card {
                  width: 350px !important;
                }
                .totals-row {
                  padding: 5px 10px !important;
                  font-size: 12px !important;
                }
                .totals-final {
                  padding: 8px 10px !important;
                  font-size: 14px !important;
                  background-color: #f0f0f0 !important;
                }
                table {
                  page-break-inside: avoid !important;
                  width: 100% !important;
                }
                tr {
                  page-break-inside: avoid !important;
                }
                thead {
                  display: table-header-group !important;
                }
                .no-print {
                  display: none !important;
                }
              }
            `}
          </style>
          <PageName title="Invoice Details" />

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3 pdf-header">
            <img src={logo} className="pdf-logo" style={{ height: "auto", maxWidth: "210px" }} alt="Tech Micro USA" />
            <div className="text-end">
              <h2 className="mb-0 fw-bold pdf-title" style={{ color: "#1a3b5c", letterSpacing: "1px", textTransform: "uppercase", fontSize: "26px" }}>INVOICE</h2>
              <p className="mb-0 text-muted pdf-meta" style={{ fontSize: "13px" }}>Date: {moment(state?.date_created || Date.now()).format("MMM DD, YYYY")}</p>
              <p className="mb-0 text-muted pdf-meta" style={{ fontSize: "13px" }}>Invoice #: {state?.id}</p>
            </div>
          </div>

          {/* Row 1: Company Details & Order Information */}
          <div className="row-2-col mb-3" style={{ display: "flex", flexDirection: "row", width: "100%", gap: "14px" }}>
            <div className="col-half" style={{ flex: "1 1 50%", width: "50%" }}>
              <div className="invoice-card h-100">
                <div className="invoice-card-header">COMPANY DETAILS</div>
                <div className="invoice-card-body">
                  <p className="fw-bold text-dark">Techmicro USA</p>
                  <p>206 Far Hills Drive</p>
                  <p>Bolingbrook, IL 60440</p>
                  <p>Sales No: (630) 526 1800</p>
                  <p className="mb-0">www.techmicrousa.com</p>
                </div>
              </div>
            </div>
            <div className="col-half" style={{ flex: "1 1 50%", width: "50%" }}>
              <div className="invoice-card h-100">
                <div className="invoice-card-header">ORDER INFORMATION</div>
                <div className="invoice-card-body">
                  <div className="info-row">
                    <span className="fw-bold">Invoice Number</span>
                    <span>{state?.id}</span>
                  </div>
                  <div className="info-row">
                    <span className="fw-bold">Customer PO</span>
                    <span>{state?.customer_po || state?.customerPo || (state?.number && state?.po_no ? `${state.number} - ${state.po_no}` : (state?.number || state?.po_no || "N/A"))}</span>
                  </div>
                  <div className="info-row">
                    <span className="fw-bold">Order Date</span>
                    <span>{moment(state?.date_created || Date.now()).format("MMM DD, YYYY")}</span>
                  </div>
                  <div className="info-row">
                    <span className="fw-bold">Terms</span>
                    <span>{state?.terms || ""}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Row 2: Billing Address & Shipping Address */}
          <div className="row-2-col mb-3" style={{ display: "flex", flexDirection: "row", width: "100%", gap: "14px" }}>
            <div className="col-half" style={{ flex: "1 1 50%", width: "50%" }}>
              <div className="invoice-card h-100">
                <div className="invoice-card-header">BILLING ADDRESS</div>
                <div className="invoice-card-body">
                  <p className="fw-bold text-dark">{state?.billing?.company || `${state?.billing?.first_name || ""} ${state?.billing?.last_name || ""}`}</p>
                  {state?.billing?.company && <p>{`${state?.billing?.first_name || ""} ${state?.billing?.last_name || ""}`}</p>}
                  <p>{state?.billing?.address_1}</p>
                  {state?.billing?.address_2 && <p>{state?.billing?.address_2}</p>}
                  <p>{`${state?.billing?.city || ""}, ${state?.billing?.state || ""} ${state?.billing?.postcode || ""}`}</p>
                  <p>Ph: {state?.billing?.phone || "Not Available"}</p>
                  <p className="mb-0">{state?.billing?.email}</p>
                </div>
              </div>
            </div>
            <div className="col-half" style={{ flex: "1 1 50%", width: "50%" }}>
              <div className="invoice-card h-100">
                <div className="invoice-card-header">SHIPPING ADDRESS</div>
                <div className="invoice-card-body">
                  <p className="fw-bold text-dark">{state?.shipping?.company || `${state?.shipping?.first_name || ""} ${state?.shipping?.last_name || ""}`}</p>
                  {state?.shipping?.company && <p>{`${state?.shipping?.first_name || ""} ${state?.shipping?.last_name || ""}`}</p>}
                  <p>{state?.shipping?.address_1}</p>
                  {state?.shipping?.address_2 && <p>{state?.shipping?.address_2}</p>}
                  <p>{`${state?.shipping?.city || ""}, ${state?.shipping?.state || ""} ${state?.shipping?.postcode || ""}`}</p>
                  <p>Ph: {state?.shipping?.phone || "Not Available"}</p>
                  <p className="mb-0">{state?.shipping?.email}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Row 3: Sale Order / Shipped Via / Currency Strip */}
          <div className="mb-3">
            <Table bordered responsive className="mb-0 invoice-table" style={{ tableLayout: "fixed", width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: "33.333%" }}>SALE ORDER</th>
                  <th style={{ width: "33.333%" }}>SHIPPED VIA</th>
                  <th style={{ width: "33.333%" }}>CURRENCY</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{state?.id}</td>
                  <td>{state?.shipping_lines?.[0]?.method_title || state?.shipBy || state?.shippingVia || state?.shipping_via || "Ground 5 - 7 Days"}</td>
                  <td>USD</td>
                </tr>
              </tbody>
            </Table>
          </div>

          {/* Row 4: Line Items Table */}
          <div className="mb-3">
            <Table bordered responsive hover className="mb-0 invoice-table" style={{ tableLayout: "fixed", width: "100%" }}>
              <thead>
                <tr className="text-center">
                  <th style={{ width: "15%" }}>ITEM #</th>
                  <th style={{ width: "13%" }}>PART NO.</th>
                  <th style={{ width: "6%" }}>QTY</th>
                  <th className="text-start" style={{ width: "36%" }}>DESCRIPTION</th>
                  <th style={{ width: "13%", whiteSpace: "nowrap" }}>PRICE</th>
                  <th className="text-end" style={{ width: "17%", whiteSpace: "nowrap" }}>EXT PRICE</th>
                </tr>
              </thead>
              <tbody>
                {state?.line_items?.map((item, index) => (
                  <tr className="text-center align-middle" key={index}>
                    <td style={{ wordBreak: "break-all" }}>{item?.sku || "-"}</td>
                    <td style={{ wordBreak: "break-all" }}>{item?.sku?.slice(4) || item?.sku || "-"}</td>
                    <td>{item?.quantity ?? 0}</td>
                    <td className="text-start" style={{ wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>
                      {item?.description ? item.description.replace(/<br\s*\/?>/gi, " ").replace(/<[^>]+>/g, "").trim() : (item?.name || "N/A")}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>${formatNumberWithCommas((parseFloat(item?.price) || 0).toFixed(2))}</td>
                    <td className="text-end fw-bold" style={{ whiteSpace: "nowrap" }}>${formatNumberWithCommas(((parseFloat(item?.price) || 0) * (parseFloat(item?.quantity) || 0)).toFixed(2))}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Row 5: Tracking Information & Totals */}
          <div className="row-2-col mt-3" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", gap: "14px" }}>
            <div style={{ flex: "1 1 55%", width: "55%" }}>
              {orderLabels?.length > 0 && (
                <div className="invoice-card mb-0">
                  <div className="invoice-card-header">TRACKING INFORMATION</div>
                  <div className="invoice-card-body p-2">
                    <Table size="sm" borderless responsive className="mb-0" style={{ fontSize: "12px" }}>
                      <thead style={{ borderBottom: "1px solid #dee2e6" }}>
                        <tr>
                          <th className="pb-1" style={{ fontSize: "11px" }}>Created On</th>
                          <th className="pb-1" style={{ fontSize: "11px" }}>Qty</th>
                          <th className="pb-1" style={{ fontSize: "11px" }}>Shipping Co.</th>
                          <th className="pb-1" style={{ fontSize: "11px" }}>Tracking</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderLabels
                          ?.filter(label => label?.labelData?.trackingType !== "Coming To Techmicro")
                          ?.filter(label => {
                            return label?.lineItemDetails?.some(labelLine =>
                              state?.line_items?.some(orderLine => orderLine?._id === labelLine?._id)
                            );
                          })
                          ?.map((item, index) => {
                            const matchedDetails = (item?.lineItemDetails || []).filter(labelLine =>
                              state?.line_items?.some(orderLine => orderLine?._id === labelLine?._id)
                            );
                            const totalQty = matchedDetails.reduce((sum, d) => sum + (Number(d?.quantity) || 0), 0);
                            return (
                              <tr key={index} className="border-bottom">
                                <td className="py-1">{moment(item?.createdAt).format('l')}</td>
                                <td className="py-1">{totalQty}</td>
                                <td className="py-1">
                                  {item?.labelData?.trackingData?.output?.completeTrackResults?.[0]?.trackResults?.[0]?.serviceDetail?.description
                                    || item?.labelData?.type || '-'}
                                </td>
                                <td className="py-1 fw-bold text-primary">{item?.labelData?.trackingNumber || 'N/A'}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              )}
            </div>
            <div className="totals-card" style={{ flex: "0 0 340px", width: "340px", marginLeft: "auto" }}>
              <div className="invoice-card">
                <div className="d-flex justify-content-between border-bottom totals-row" style={{ padding: "5px 10px", fontSize: "13px", backgroundColor: "#fcfcfc" }}>
                  <span className="fw-bold">Sub Total:</span>
                  <span>${formatNumberWithCommas(calculatedSubtotal.toFixed(2))}</span>
                </div>
                <div className="d-flex justify-content-between border-bottom totals-row" style={{ padding: "5px 10px", fontSize: "13px" }}>
                  <span>Tax:</span>
                  <span>${formatNumberWithCommas(totalTax.toFixed(2))}</span>
                </div>
                <div className="d-flex justify-content-between border-bottom totals-row" style={{ padding: "5px 10px", fontSize: "13px" }}>
                  <span>Shipping:</span>
                  <span>${formatNumberWithCommas((parseFloat(state?.totalTaxAmount?.shippingAmount ?? 0)).toFixed(2))}</span>
                </div>
                <div className="d-flex justify-content-between border-bottom totals-row" style={{ padding: "5px 10px", fontSize: "13px" }}>
                  <span>Insurance:</span>
                  <span>${formatNumberWithCommas((parseFloat(state?.totalTaxAmount?.insurance ?? 0)).toFixed(2))}</span>
                </div>
                <div className="d-flex justify-content-between border-bottom totals-row" style={{ padding: "5px 10px", fontSize: "13px" }}>
                  <span>Discount:</span>
                  <span className="text-danger">-${formatNumberWithCommas((parseFloat(state?.totalTaxAmount?.discount ?? 0)).toFixed(2))}</span>
                </div>
                <div className="d-flex justify-content-between totals-final" style={{ padding: "8px 10px", fontSize: "14px", backgroundColor: "#f0f0f0", color: "#000" }}>
                  <span className="fw-bold text-uppercase">ORDER TOTAL:</span>
                  <span className="fw-bold">${formatNumberWithCommas(calculatedTotal.toFixed(2))}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Row>
        <Col md={10} className="d-flex justify-content-end mt-0 gap-2 mx-auto">
          <GeneralButton
            title="Print / Save as PDF"
            className="blue-button mb-3"
            width="220px"
            handleClick={() => handlePrint()}
          />
          <GeneralButton
            title="Send PDF"
            className="blue-button"
            handleClick={sendPdfToEmail}
            loading={loading}
          />
        </Col>
      </Row>
    </>
  );
};
export default Invoice;
